export enum PopupType {
    SEARCH = <any>'S',
    ADD = <any>'A'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/property-popup-type.enum.ts